import { render, staticRenderFns } from "./AsignarRuta.vue?vue&type=template&id=55ad89ef"
import script from "./AsignarRuta.vue?vue&type=script&lang=js"
export * from "./AsignarRuta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports